/**
 * 铺位信息编辑
 */
import React, { Component } from 'react';
import { Modal, Form, Input, InputNumber, Select, Col, Row, Table, Tooltip, Icon ,Switch } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
// import validator from '../../../util/validator';

import { fixedNumber, copyObject } from '../../../util/util.js';

const fields = [{
    "text": "所属楼层",
    "field": "floorId",
    "floor": true,
    rules: [
        { required: true, message: '所属楼层不能为空!' },
    ]
}, {
    "text": "铺位编号",
    "field": "berthCode",
    rules: [
        { required: true, message: '铺位编号不能为空!' },
        { max: 32, message: '铺位编号不能超过32个字符！' },
        // validator.lineEnNum
    ]
}, 
// {
//     "text": "计租面积(㎡)",
//     "field": "area",
//     "number": true,
//     rules: [
//         { required: true, message: '铺位面积不能为空!' },
//     ]
// },
 {
    "text": "计租面积(㎡)",
    "field": "buildingArea",
    "number": true,
    rules: [
        { required: true, message: '建筑面积不能为空!' },
    ]
}
,{
    "text": "物业费(元/㎡/月)",
    "field": "propertyCost",
    "number": true,
    rules: [
        { required: true, message: '物业费不能为空!' },
    ]
}
, {
    "text": "出租几年",
    "field": "yearNum",
    "disabled": true,
}, {
    "text": "租金总额",
    "field": "totalRent",
    "disabled": true,
}, {
    "text": "平均每年租金",
    "field": "averageRent",
    "disabled": true,
}
// ,{
//     "text": "出租状态",
//     "field": "status",
//     radio: true,
//     rules: [
//         { required: true, message: '出租状态不能为空!' },
//     ]
// }
];


class BerthEditForm extends Component {

    columns = [{
        title: '年份',
        dataIndex: 'year',
        width: '10%',
    }, {
        title: '租金(元)',
        dataIndex: 'rent',
        width: '20%',
        render: (value, row, index) => {
            return <InputNumber precision={2} min={0} style={{ width: '100%' }} value={value} onChange={this.rentChage.bind(this, index)} />
        },
    }, {
        title: '操作',
        dataIndex: 'opt',
        width: '10%',
        render: (value, row, index) => {
            let dom = [];
            if (this.state.rentList.length === (index + 1)) {
                dom.push(<Tooltip key="plus" title="增加">
                    <Icon type="plus" className="table-operate-icon" onClick={this.addRent.bind(this, index)} />
                </Tooltip>);
                if (index !== 0) {
                    dom.push(<Tooltip key="minus" title="删除">
                        <Icon type="minus" className="table-operate-icon" onClick={this.deleteRent.bind(this, index)} />
                    </Tooltip>);
                }
            }
            return dom;
        },
    }];

    componentDidMount = () => {
        //将初始化函数返回回去
        this.props.initEdit(this.initEdit);
    }

    state = {
        rentList: [],
        area: 0
    }

    /** 每次刚开始修改的时候初始化 */
    initEdit = (rentList, area) => {
        // this.setState({ rentList: rentList });
        // this.setState({ rentList: [...rentList] });
        // this.setState({ rentList: Array.from(rentList) });
        this.setState({ rentList: copyObject(rentList), area: area });
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            fields.forEach((json, index) => {
                if (json["radio"] === true) {
                    values[json["field"]] = values[json["field"]] ? 1 : 0;
                }
            })
            let rentListJsonStr = JSON.stringify(this.state.rentList);
            values["rentListJsonStr"] = rentListJsonStr;
            http.post({
                url: '/berth/saveBerth',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (fields) => {
        const { form, editData, floorList } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < fields.length; i++) {
            let item = fields[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.radio ? editData[item.field] === 1 : editData[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.number ?
                                <InputNumber precision={2} min={0.00} style={{ width: '100%' }} onChange={this.numberInputChange.bind(this, item.field)} />
                                : item.floor ?
                                    <Select>
                                        {floorList.map(d =>
                                            <Select.Option
                                                key={d["id"]}>
                                                {d["floorName"]}
                                            </Select.Option>
                                        )}
                                    </Select>
                                    : item.radio ?
                                    <Switch checkedChildren="是" unCheckedChildren="否" />:<Input disabled={item.disabled} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    create2Col = (fields) => {
        let dom = this.createDom(fields);
        let result = [];
        for (let i = 0; i < dom.length; i++) {
            let item = <Col key={i} span={11} offset={i % 2 === 0 ? 0 : 2}>{dom[i]}</Col>;
            result.push(item);
        }
        return result;
    }

    numberInputChange = (field, value) => {
        if (field === "buildingArea") {
            let rentList = this.state.rentList;
            this.setState({area: value});
            this.calculateRent(rentList, value);
        }
    }

    rentChage = (index, value) => {
        let rentList = this.state.rentList;
        rentList[index]["rent"] = value;
        this.calculateRent(rentList, this.state.area);
        this.setState({ rentList: rentList });
    }

    addRent = (index, e) => {
        let rentList = this.state.rentList;
        let rent = {
            year: parseInt(rentList[index]["year"]) + 1,
            rent: 0
        };
        rentList.push(rent);
        this.setState({ rentList: rentList });
        this.calculateRent(rentList, this.state.area);
    }

    deleteRent = (index, e) => {
        let rentList = this.state.rentList;
        rentList.pop();
        this.setState({ rentList: rentList });
        this.calculateRent(rentList, this.state.area);
    }

    /** 计算租金信息 */
    calculateRent = (rentList, area) => {
        const { form } = this.props;
        let totalRent = 0;
        let averageRent = 0;
        let yearNum = rentList.length;
        for (let i in rentList) {
            let rent = rentList[i]["rent"];
            rent = rent == null || rent === "" ? 0 : rent;
            totalRent += parseFloat(rent);
        }
        totalRent = totalRent * area * 12;
        totalRent = fixedNumber(totalRent, 0);
        averageRent = fixedNumber(totalRent / yearNum, 0);

        form.setFieldsValue({ totalRent, averageRent, yearNum });
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                width={800}
                title="铺位信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields(); this.setState({ rentList: [] }) }}
            >
                <Form layout="vertical" labelCol={{ span: 9 }} wrapperCol={{ span: 15 }}>
                    <Row>
                        {this.create2Col(fields)}
                    </Row>
                    <Row>
                        <Table rowKey="year" columns={this.columns} dataSource={this.state.rentList} tableLayout="fixed" pagination={false} bordered={true} />
                    </Row>
                </Form>
            </Modal>
        );
    }
}

const BerthEdit = Form.create()(BerthEditForm);

export default BerthEdit;